export const formatPricingDecimal = (value) => {
	const num = Number(value);
	return Number.isFinite(num) ? num.toFixed(3) : "0.000";
};
